import { useState } from 'react'

import { List, Section } from '@factorialco/deprecated-design-system'
import { DeleteOverlapPeriodDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import DeletePeriodModal from 'modules/work_schedules/components/DeletePeriodModal'
import overlapPeriods from 'modules/work_schedules/store/collections/overlapPeriods'

import BlankSlate from './BlankSlate'
import Item from './Item'

const PeriodSection = ({ id }: { id: string }) => {
  const periods = overlapPeriods.getNonDefaultPeriods(id)
  const { navigation } = useNavigation()
  const [periodToDelete, setPeriodToDelete] = useState<string | null>(null)

  const [deleteOverlapPeriod] = useMutation(DeleteOverlapPeriodDocument, {
    extractorFn: (data) => data.workScheduleMutations.deleteWorkscheduleOverlapPeriod,
  })

  const handleDeletePeriod = (periodId: string) => {
    setPeriodToDelete(periodId)
  }

  const confirmDeletePeriod = async (closePortal: () => void) => {
    if (!periodToDelete) return

    const result = await deleteOverlapPeriod({
      variables: { id: periodToDelete },
    })

    const handled = handleResult(result, () => {})

    if (handled.success) {
      closePortal()
      overlapPeriods.fetch({ data: { schedule_id: id } })
    }
  }

  const closeModal = () => {
    setPeriodToDelete(null)
  }

  return (
    <>
      <Section.TwoThirds
        illustration="browser-edit"
        title={i18n.t('settings.work_schedule.period_section.title')}
        description={i18n.t('settings.work_schedule.period_section.description')}
        action={{
          label: i18n.t('settings.work_schedule.period_section.add'),
          to: navigation.settings.workSchedule.id.periodNew.fullPath({ id: id }),
        }}
      >
        <List>
          {!periods.length ? (
            <BlankSlate />
          ) : (
            periods.map((period, idx) => (
              <List.Item key={period.attributes.id}>
                <Item
                  itemName={`${i18n.t('settings.work_schedule.period_section.period')} ${idx + 1}`}
                  period={period}
                  onDeletePeriod={handleDeletePeriod}
                />
              </List.Item>
            ))
          )}
        </List>
      </Section.TwoThirds>

      {periodToDelete && <DeletePeriodModal onClose={closeModal} onConfirm={confirmDeletePeriod} />}
    </>
  )
}

export default observer(PeriodSection)
